var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragAndDrop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 10.5002C3.25 11.3252 2.575 12.0002 1.75 12.0002C0.925 12.0002 0.25 11.3252 0.25 10.5002C0.25 9.67524 0.925 9.00024 1.75 9.00024C2.575 9.00024 3.25 9.67524 3.25 10.5002ZM1.75 4.50024C0.925 4.50024 0.25 5.17524 0.25 6.00024C0.25 6.82524 0.925 7.50024 1.75 7.50024C2.575 7.50024 3.25 6.82524 3.25 6.00024C3.25 5.17524 2.575 4.50024 1.75 4.50024ZM1.75 0.000244141C0.925 0.000244141 0.25 0.675244 0.25 1.50024C0.25 2.32524 0.925 3.00024 1.75 3.00024C2.575 3.00024 3.25 2.32524 3.25 1.50024C3.25 0.675244 2.575 0.000244141 1.75 0.000244141ZM6.25 3.00024C7.075 3.00024 7.75 2.32524 7.75 1.50024C7.75 0.675244 7.075 0.000244141 6.25 0.000244141C5.425 0.000244141 4.75 0.675244 4.75 1.50024C4.75 2.32524 5.425 3.00024 6.25 3.00024ZM6.25 4.50024C5.425 4.50024 4.75 5.17524 4.75 6.00024C4.75 6.82524 5.425 7.50024 6.25 7.50024C7.075 7.50024 7.75 6.82524 7.75 6.00024C7.75 5.17524 7.075 4.50024 6.25 4.50024ZM6.25 9.00024C5.425 9.00024 4.75 9.67524 4.75 10.5002C4.75 11.3252 5.425 12.0002 6.25 12.0002C7.075 12.0002 7.75 11.3252 7.75 10.5002C7.75 9.67524 7.075 9.00024 6.25 9.00024Z",
    fill: "#CDCDCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragAndDrop);
export default __webpack_public_path__ + "static/media/drag_and_drop.108fb58958a90aff4dab1b91385bff97.svg";
export { ForwardRef as ReactComponent };